import { Routes } from "@angular/router";
import { AuthGuardFrontUsers } from "../../shared/services/auth-guard/auth-guard-frontusers.service";
import { AuthGuardLogin } from "../../shared/services/auth-guard/auth-guard-login.service";
import { AppLayoutComponent } from "../app-layout/app-layout.component";
import { CardListComponent } from "./card-list/card-list.component";
import { CheckoutComponent } from "./checkout/checkout.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { SavedBookingsComponent } from "./saved-bookings/saved-bookings.component";
import { WishlistComponent } from "./wishlist/wishlist.component";

export const mainRoutes: Routes = [
  {
    path: "",
    component: AppLayoutComponent,
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
          ],
        },
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
      },
      {
        path: "checkout",
        component: CheckoutComponent,
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
      },
      {
        path: "saved_bookings",
        component: SavedBookingsComponent,
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
            {
              title: "Saved Bookings",
            },
          ],
        },
      },
      {
        path: "cards",
        component: CardListComponent,
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
            {
              title: "Manage Cards",
            },
          ],
        },
      },
      {
        path: "orders",
        loadChildren: () =>
          import("./orders/orders-routes").then((m) => m.routes),
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
            {
              title: "Orders",
            },
          ],
        },
      },
      {
        path: "subscription",
        loadChildren: () =>
          import("./subscription/subscription-routes").then((m) => m.routes),
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
            {
              title: "My Subscription",
            },
          ],
        },
      },
      {
        path: "pets",
        loadChildren: () => import("./pets/pets-routes").then((m) => m.routes),
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
            {
              title: "My Pets",
            },
          ],
        },
      },
      {
        path: "booking",
        loadChildren: () =>
          import("./booking/booking-routes").then((m) => m.routes),
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
            {
              title: "My Booking",
            },
          ],
        },
      },
      {
        path: "profile",
        loadChildren: () =>
          import("./profile/profile-routes").then((m) => m.routes),
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
            {
              title: "Manage Profile",
            },
          ],
        },
      },
      {
        path: "wishlist",
        component: WishlistComponent,
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
            {
              title: "My Wishlist",
            },
          ],
        },
      },
      {
        path: "health_map_report/:petId/:tabValue",
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "My Pets",
              url: "/pets",
            },
            {
              title: "View Health Map",
            },
          ],
        },
        loadChildren: () =>
          import("./health-map-reports/health-map-reports-routes").then(
            (m) => m.routes
          ),
        canActivate: [AuthGuardLogin, AuthGuardFrontUsers],
      },
    ],
  },
];
